import { CheckCircle } from 'lucide-react'

const REGISTRATION_STEPS = [
    {
        id: 1,
        name: 'Legal Entity Details',
        shortName: 'Legal Details'
    },
    {
        id: 2,
        name: 'Profile Building',
        shortName: 'Profile'
    },
    {
        id: 3,
        name: 'Subscription Plan',
        shortName: 'Subscription'
    },
    {
        id: 4,
        name: 'Document Upload',
        shortName: 'Documents'
    }
]

const StepIndicator = ({ currentStep = 1 }) => {
    return (
        <div className="w-full mb-6">
            <div className="bg-white dark:bg-secondary-800 rounded-lg p-4 border border-secondary-200 dark:border-secondary-700 shadow-glow">
                <div className="flex items-center justify-between mb-3">
                    <h3 className="text-sm font-bold text-secondary-900 dark:text-secondary-100">
                        Step {currentStep} of {REGISTRATION_STEPS.length}
                    </h3>
                    <div className="text-xs text-secondary-600 dark:text-secondary-400 font-medium">
                        {Math.round(((currentStep - 1) / REGISTRATION_STEPS.length) * 100)}% Complete
                    </div>
                </div>
                <div className="flex items-center justify-between">
                    {REGISTRATION_STEPS.map((step, index) => (
                        <div key={step.id} className="flex items-center flex-1">
                            <div className="flex flex-col items-center flex-1 relative">
                                <div
                                    className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold transition-all duration-300 ${currentStep === step.id
                                            ? 'bg-primary-600 text-white scale-110 ring-2 ring-primary-300 dark:ring-primary-800 shadow-lg'
                                            : currentStep > step.id
                                                ? 'bg-success-500 text-white scale-100 shadow-md'
                                                : 'bg-secondary-200 dark:bg-secondary-700 text-secondary-500 dark:text-secondary-400 scale-100'
                                        }`}
                                >
                                    {currentStep > step.id ? <CheckCircle className="w-4 h-4" /> : step.id}
                                </div>
                                <span
                                    className={`text-[10px] mt-1.5 font-medium text-center max-w-[70px] leading-tight ${currentStep === step.id
                                            ? 'text-primary-700 dark:text-primary-400 font-semibold'
                                            : currentStep > step.id
                                                ? 'text-success-600 dark:text-success-400'
                                                : 'text-secondary-500 dark:text-secondary-400'
                                        }`}
                                >
                                    {step.shortName}
                                </span>
                            </div>
                            {index < REGISTRATION_STEPS.length - 1 && (
                                <div
                                    className={`flex-1 h-0.5 mx-2 rounded-full transition-all duration-300 ${currentStep > step.id
                                            ? 'bg-success-500 shadow-sm'
                                            : currentStep === step.id
                                                ? 'bg-primary-300 dark:bg-primary-700'
                                                : 'bg-secondary-200 dark:bg-secondary-700'
                                        }`}
                                />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default StepIndicator
